import { useState, useEffect, useRef } from "react";
import { useControls } from "leva";
import SceneManager from "./components/manager/SceneManager";
import MobileUI from "./components/ui/MobileUI/MobileUI";

export default function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const resizeTimeout = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
      resizeTimeout.current = setTimeout(() => {
        setIsMobile(window.innerWidth < 1024);
      }, 100); // 200ms de debounce, ajuste selon tes besoins
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
    };
  }, []);

  const perfVisible = import.meta.env.DEV
    ? useControls({ perfVisible: true }).perfVisible
    : false;

  return (
    <>
      {isMobile ? <MobileUI /> : <SceneManager perfVisible={perfVisible} />}
    </>
  );
}
